import React from 'react';

const WolkingTime = ({ value }) => {
    const minutes = Math.floor(value / 60);
    return <span>{minutes}</span>;
};

export default WolkingTime;
